/* gorilla-richtext.js — Shopify rich text JSON → HTML renderer
   Content source: Shopify admin metafields (merchant-controlled, not user input).
   All text node values are HTML-escaped before insertion. */
(function () {
  'use strict';

  function esc(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function renderNode(node) {
    if (!node) return '';
    var kids = node.children ? node.children.map(renderNode).join('') : '';
    switch (node.type) {
      case 'root':      return kids;
      case 'paragraph': return kids ? '<p>' + kids + '</p>' : '';
      case 'heading':   var l = node.level || 2; return '<h'+l+'>'+kids+'</h'+l+'>';
      case 'list':      var t = node.listType === 'ordered' ? 'ol' : 'ul'; return '<'+t+'>'+kids+'</'+t+'>';
      case 'list-item': return '<li>' + kids + '</li>';
      case 'link': {
        var href   = node.url    ? ' href="'   + esc(node.url)    + '"' : '';
        var target = node.target ? ' target="' + esc(node.target) + '"' : '';
        return '<a' + href + target + '>' + kids + '</a>';
      }
      case 'text': {
        var text = esc(node.value || '');
        if (node.bold)      text = '<strong>' + text + '</strong>';
        if (node.italic)    text = '<em>'     + text + '</em>';
        if (node.underline) text = '<u>'      + text + '</u>';
        if (node.strike)    text = '<s>'      + text + '</s>';
        if (node.code)      text = '<code>'   + text + '</code>';
        return text;
      }
      default: return kids;
    }
  }

  function parse(str) {
    var s = str.trim();
    if (s.charAt(0) !== '{' && s.charAt(0) !== '[') return null;
    /* Shopify may output Ruby hash syntax — normalise to JSON */
    s = s.replace(/=>/g, ':').replace(/\bnil\b/g, 'null');
    try { return JSON.parse(s); } catch (e) { return null; }
  }

  function renderEl(el) {
    var parsed = parse(el.textContent.trim());
    if (!parsed) return;
    /* Safe: only text nodes are inserted — all values HTML-escaped above */
    el.innerHTML = renderNode(parsed); /* nosec */
  }

  function processAll() {
    document.querySelectorAll('[data-richtext]').forEach(renderEl);
  }

  document.addEventListener('DOMContentLoaded', processAll);

  window.GorillaRichText = { process: processAll, renderEl: renderEl };
})();
